import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ children }) => {
  const { user } = useSelector((state) => state.login);
  const userData = localStorage.getItem('userData');
  
  // Check if user is authenticated (either in Redux state or localStorage)
  if (!user && !userData) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

export default ProtectedRoute;